import {
    option_textMessaging_subcategory,
    option_textMessaging_searchterms,
} from './textMessagingSubCategory.locstring.json';
import { createLazyOption, OptionSubCategory } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import getStore from './store/store';
import loadTextMessagingAccount from './store/loadTextMessagingAccount';

const lazyModule = new LazyModule(() => import('./components/lazyTextMessagingOption'));

// Need to pre-load this setting so we know if we should show the text messaging category at all.
loadTextMessagingAccount();

export default {
    key: 'textMessaging',
    titleStringKey: option_textMessaging_subcategory,
    options: [
        createLazyOption(
            {
                key: 'disable_sms',
                titleStringKey: option_textMessaging_subcategory,
                hideTitleInFullOptions: true,
                searchTermsStringKey: option_textMessaging_searchterms,
                allowedOptionKeys: ['TextMessaging'],
                isHidden: () => getStore().isHidden,
            },
            lazyModule,
            m => m.default
        ),
    ],
} as OptionSubCategory;
